import { InfoIcon, PencilIcon, Trash2 } from 'lucide-react'
import { cn } from '@/lib/tailwind.utils'
import { RiskWorkspace } from '@app/types'
import { Link } from 'react-router-dom'
import { appLink } from '@app/config/appLink'

type WorkspaceActionsProps = {
  workspace: RiskWorkspace
  setDeleteDialog: (workspaceId: string | null) => void
  setInformationDialog: (workspaceId: string | null) => void
  setSelectedDialogWorkspace: (workspace: RiskWorkspace | null) => void
}

export const WorkspaceActions = ({
  workspace,
  setDeleteDialog,
  setInformationDialog,
  setSelectedDialogWorkspace,
}: WorkspaceActionsProps) => {
  const buttonStyles =
    'border rounded-md p-1 h-7 w-7 flex flex-row justify-center items-center hover:bg-slate-100'
  const iconStyles = 'text-primary h-3.5 w-3.5'

  return (
    <div className="flex gap-2">
      <button
        className={buttonStyles}
        onClick={() => {
          setInformationDialog(workspace.id)
          setSelectedDialogWorkspace(workspace)
        }}
      >
        <InfoIcon className={iconStyles} />
      </button>
      <Link to={`${appLink.workspaces.path}/${workspace.id}/edit`}>
        <button className={buttonStyles}>
          <PencilIcon className={iconStyles} />
        </button>
      </Link>
      <button
        className={buttonStyles}
        onClick={() => {
          setDeleteDialog(workspace.id)
          setSelectedDialogWorkspace(workspace)
        }}
      >
        <Trash2 className={cn(iconStyles, 'text-red-600')} />
      </button>
    </div>
  )
}
